export const CORRECT_ANSWER_COLOR = 'lightgreen';
export const INCORRECT_ANSWER_COLOR = 'lightcoral';
export const DEBATABLE_ANSWER_COLOR = '#a2c5ed';
export const SELECTED_ANSWER_COLOR = 'lightgray';
export const MATCH_PAIR_SELECTED_COLOR = '#3b82f6';
